import { combineEpics } from "redux-observable";
import { messageDismissAllEpicReducer } from "../ducks/messageDismissAll.duck.js";
const dismissAllMessgeEpic = combineEpics(messageDismissAllEpicReducer.epic);
export {
  dismissAllMessgeEpic
};
//# sourceMappingURL=messageDismissAll.epic.js.map
